'use client';

import { useEffect, useState } from 'react';

import * as Scroll from 'react-scroll';
import styled from 'styled-components';
import { throttle } from 'lodash-es';

import { ScrollIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { useFooterContext } from '@contexts/footer';
import { useDevice } from '@contexts/device';
const Button = styled.button<{ visible: boolean; isFooterVisible?: boolean }>`
  border-radius: 50%;
  width: 60px;
  height: 60px;
  position: fixed;
  bottom: 150px;
  right: 16px;
  background-color: transparent;
  border: 2px solid
    ${({ theme, isFooterVisible }) =>
      isFooterVisible ? theme.palette.white : theme.palette.darkGrey};
  cursor: pointer;
  z-index: 999;
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  transition: all 0.15s ease-in-out;
`;
const UpArrowIcons = styled.div`
  justify-content: center;
  margin-top: 6px;
  display: flex;
`;

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);
  const [mounted, setMounted] = useState(false);
  const { isDesktop } = useDevice();

  const { isVisible: isFooterVisible } = useFooterContext();

  const scrollHandler = () => {
    if (window.scrollY === 0) {
      setShowButton(false);
    } else setShowButton(true);
  };

  useEffect(() => {
    window.addEventListener('scroll', throttle(scrollHandler, 200), {
      passive: true,
    });
    setMounted(true);

    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);
  return mounted && isDesktop ? (
    <Button
      visible={showButton}
      isFooterVisible={isFooterVisible}
      onClick={() => Scroll.animateScroll.scrollToTop()}
    >
      <UpArrowIcons>
        <CustomIcon
          icon={ScrollIcon}
          fontSize={36}
          paletteColor={isFooterVisible ? 'white' : 'darkGrey'}
        />
      </UpArrowIcons>
    </Button>
  ) : null;
};

export default ScrollToTop;
